/*  ========================================================================
    # Hooks - Use Breakpoints
    ========================================================================  */

import { useEffect, useState } from 'react';
import tailwindConfig from '../../../tailwind.config.js';

/**
 * Hook to get the current viewport width and check if it matches the breakpoints.
 */
const useBreakpoints = () => {
  const [viewportWidth, setViewportWidth] = useState(window.innerWidth);
  const handleResize = () => setViewportWidth(window.innerWidth);

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [window, handleResize]);

  return {
    sm: viewportWidth >= parseInt(tailwindConfig.theme.screens.sm, 10),
    md: viewportWidth >= parseInt(tailwindConfig.theme.screens.md, 10),
    lg: viewportWidth >= parseInt(tailwindConfig.theme.screens.lg, 10),
    xl: viewportWidth >= parseInt(tailwindConfig.theme.screens.xl, 10),
    xxl: viewportWidth >= parseInt(tailwindConfig.theme.screens.xxl, 10)
  };
};

export default useBreakpoints;
